import styled from 'styled-components';
import { GlassPanel } from './GlassPanel';

export const DialogPanel = styled(GlassPanel)`
  min-width: 360px;
  background-color: ${(p) => p.theme.colors.black};
  overflow: hidden;
`;
